export default "__VITE_ASSET__aaeEElUu__"